import CalendarGroup from 'owa-service/lib/contract/CalendarGroup';
import CalendarGroupType from 'owa-service/lib/contract/CalendarGroupType';
import { AllCalendarEntry } from '../schema/AllCalendarEntry';

export const isCalendarEntryForPeopleCalendar = (
    calendarEntry: AllCalendarEntry,
    group: CalendarGroup
) => (group.GroupType.valueOf() as CalendarGroupType) === CalendarGroupType.PeoplesCalendars;
